// The session's landed combos: the best one (with its full trick string) and
// the last few, for the HUD and the pause menu. Session only: nothing is saved
// until the game has progress to save it with.

export interface LandedCombo {
  /** The trick string as the HUD showed it: "Kickflip + 50-50 + Revert". */
  text: string;
  /** Sum of the tricks' points. */
  base: number;
  /** Trick count. */
  multiplier: number;
  /** What it scored: base x multiplier, rounded. */
  points: number;
}

/** How many landed combos the pause menu lists. */
export const RECENT_COMBOS = 8;

export class ComboLog {
  best: LandedCombo | null = null;
  /**
   * Newest first. Replaced (never mutated) when a combo lands, so the HUD can
   * tell it changed by reference.
   */
  recent: readonly LandedCombo[] = [];

  record(combo: LandedCombo): void {
    this.recent = [combo, ...this.recent].slice(0, RECENT_COMBOS);
    if (!this.best || combo.points > this.best.points) this.best = combo;
  }
}
